import { request } from '../index';
import axios from '@/axios';

export async function getComorbidities() {
    return await request("GET", "/comorbidities/filter");
}

export async function saveComorbidity(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/comorbidities/${id}` : '/comorbidities/create';
    return await axios({ method, url, data });
}
